import {Header, Navigation} from "../partials/header";
import { useEffect, useRef } from "react";

const IS_PRODUCTION = process.env.NODE_ENV === "production";
const BACKEND_URI = IS_PRODUCTION ? process.env.REACT_APP_API_BASE_URI : "http://localhost:5050";

export default function Signup() {
    const formRef = useRef(null);
    useEffect(() => {
        document.title = "Signup";
    }, [])

    const handleSubmit = async (event) => {
        event.preventDefault(); // Prevent default form submission

        const formData = new FormData(formRef.current); // Create FormData object from the form
        const data = Object.fromEntries(formData);

        try {
            // Create the user
            // console.log(data);
            const response = await fetch(`${BACKEND_URI}/user`, {
                method: 'POST',
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(data), // Send FormData directly as the body
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const result = await response.json();

            if (result.success) {
                alert("Account created successfully! Please log in.");
                window.location.href = "/"; // Redirect to the homepage
            } else {
                alert(result.details);
            }
        } catch (error) {
            console.error('Error:', error);
            alert('Signup failed');
        }
    };

    return (
        <div className="theme-container">
            <Navigation />

            <div className="main-content">
                <Header />

                {/* Page Content */}
                <div className="page-content">
                    <div className="content-wrapper">
                        <h1 className="page-heading">
                            Create an Account
                        </h1>
                        <div className="content-card">
                            <h2 className="card-title">
                                Please signup in order to use our website
                            </h2>
                            <div className="card-text">
                                Signup
                                <form ref={formRef} onSubmit={handleSubmit}>
                                    <input type="text" name="username" placeholder="Username" required />
                                    <input type="text" name="password" placeholder="Password" required />

                                    <input type="submit" value="Create Account" id="submit" />
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}